import styled from 'styled-components'

import {
  FaRegCalendarAlt,
  FaRegClock,
  FaCogs,
  FaUserTie,
  FaRegBookmark,
  FaRegTrashAlt,
  FaCheck
} from "react-icons/fa"


export const Container = styled.div`
width: 100%;
height: 100vh;
background-color: ${({ theme }) => theme.colors.background};
padding: 0;
margin: 0;
overflow: none;
`;

export const ContentContainer = styled.div`
  width: 100%;  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.colors.background};
  padding-top: 16px;   
`

// `isFallback` = negocio sem imagem (url nula ou quebrada). Nesse caso
// mostra a logo do app sobre fundo bege, com `contain` + padding para a
// logo (1.51:1) caber inteira no container quase quadrado, sem cortar.
export const Logo = styled.div`
  width: 50vw;
  height: 45vw; 
  background-color: ${({ theme }) => theme.colors.background};
  background-image: url(${({ url }) => url});
  background-size: ${({ isFallback }) => isFallback ? 'contain' : 'cover'};
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: content-box;  
  padding: ${({ isFallback }) => isFallback ? '16px' : '0'};
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 14px;
  margin-bottom: 32px;

  @media (min-width: 768px) {
    width: 10vw;
    height: 10vw;
  }
  `

export const SchedulingContentContainer = styled.div`
  width: 100%;  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.colors.background};
  padding-top: 16px;
  overflow: scroll;    

  @media (min-width: 768px) {
    padding-left: 20%;
    padding-right: 20%;
  }

   @media (min-width: 1024px) {
    padding-left: 30%;
    padding-right: 30%;
  }
`

// Card de agendamento: superficie ESCURA sobre o bege, mesmo tratamento do
// card do ServiceList do beuddy.
export const SchedulingContainer = styled.div`
    width: 90%;
    height: 115px;
    background-color: ${({ theme }) => theme.colors.surface};
    display: flex;
    flex-direction: row;
    border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
    border-radius: 14px;
    margin-bottom: 8px;
    transition: border-color 0.2s, background-color 0.2s;

    &:hover {
      border-color: ${({ theme }) => theme.colors.accentOnSurface};
    }

    &:active {
      background-color: ${({ theme }) => theme.colors.surfaceAlt};
      border-color: ${({ theme }) => theme.colors.accentOnSurface};
    }
  `

export const SchedulingLeftContainer = styled.div`
  flex: 2;
  position:relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding-top: 8px;
  padding-bottom: 8px;

  &::after {
    content: '';
    position: absolute;
    border-right: 1px solid ${({ theme }) => theme.colors.surfaceDivider};
    height: 80%;
    top: 10%;   
    right: 0;
}
`

export const SchedulingRightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 6;  
  padding-left: 12px;
`

// `isColorfull` marca a coluna da direita (servico, profissional, status),
// que e informacao secundaria -> `surfaceTextSecondary`. A coluna da
// esquerda (data e hora) fica em `surfaceText`, por ser o valor em destaque.
export const SchedulingSimpleTitle = styled.p`
    font-size: 14px;
    color: ${({ theme, isColorfull }) => isColorfull ? theme.colors.surfaceTextSecondary : theme.colors.surfaceText};
    margin: 0;
  `

export const SchedulingBigTitle = styled.p`
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme, isColorfull }) => isColorfull ? theme.colors.surfaceTextSecondary : theme.colors.surfaceText};
    margin: 0;
  `

// MODAL
// Conteudo sobre superficie CLARA (components/Modal usa `background`).

export const WrapModal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center; 
`

export const ModalTitle = styled.p`
  text-align: left;
  margin: 0; 
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
`
export const ModalContent = styled.div`
  width: 90%;
  margin-bottom: 16px;  
`
export const TitleModalContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 12px;
`

export const ModalBigTitle = styled.p`
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 1.5px;
    color: ${({ theme }) => theme.colors.textPrimary};
    margin: 0;
    margin-top: 16px;
    margin-bottom: 16px;
    text-align: center;
  `

export const CalendarIcon = styled(FaRegCalendarAlt).attrs(({ theme }) => ({
  color: theme.colors.accent,
  size: 20,
}))` 
margin: 0;
margin-right: 12px;
`

export const ClockIcon = styled(FaRegClock).attrs(({ theme }) => ({
  color: theme.colors.accent,
  size: 20,
}))` 
margin: 0;
margin-right: 12px;
`

export const ServiceIcon = styled(FaCogs).attrs(({ theme }) => ({
  color: theme.colors.accent,
  size: 20,
}))` 
margin: 0;
margin-right: 12px;
`

export const EmployeeIcon = styled(FaUserTie).attrs(({ theme }) => ({
  color: theme.colors.accent,
  size: 20,
}))` 
margin: 0;
margin-right: 12px;
`

export const StatusIcon = styled(FaRegBookmark).attrs(({ theme }) => ({
  color: theme.colors.accent,
  size: 20,
}))` 
margin: 0;
margin-right: 12px;
`

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-top: 32px;
`

// ACTION BUTTON
// `ActionButtonText` nao recebe a prop `cancel`, logo os dois botoes
// compartilham a cor do rotulo. A distincao vem da borda (aqui) e do icone
// (DeleteIcon/ConfirmIcon, que sao componentes separados). `warningBg` como
// fundo do cancelar nao serviria: fica a 1.01:1 de `surface`.
export const ActionButton = styled.div`
  width: 80px;
  height: 80px;
  background-color: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme, cancel }) => cancel ? theme.colors.warning : theme.colors.borderSubtle};
  border-radius: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:active {
    width: 85px;
    height: 85px;
    background-color: ${({ theme }) => theme.colors.surfaceAlt};
  }
`

export const ActionButtonText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.surfaceText};
  font-size: 14px;
  margin-top: 4px;
`

export const DeleteIcon = styled(FaRegTrashAlt).attrs(({ theme }) => ({
  color: theme.colors.warning,
  size: 18,
}))` 
margin: 0;
`

export const ConfirmIcon = styled(FaCheck).attrs(({ theme }) => ({
  color: theme.colors.success,
  size: 18,
}))` 
margin: 0;
`
